
import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./Home.css"; // Import your custom styles if needed
import { Link } from "react-router-dom";
const MamandurImages = () => {
    const [imageUrls, setImageUrls] = useState([
    "https://vanadarshini-images.s3.ap-south-1.amazonaws.com/mamandur-img/mam1.jpg",
    "https://vanadarshini-images.s3.ap-south-1.amazonaws.com/mamandur-img/mam2.jpg",
  
    "https://vanadarshini-images.s3.ap-south-1.amazonaws.com/mamandur-img/mam5.jpg",
    "https://vanadarshini-images.s3.ap-south-1.amazonaws.com/mamandur-img/mam6.jpg",
    "https://vanadarshini-images.s3.ap-south-1.amazonaws.com/mamandur-img/Mamandur-Forest-1.jpg",
    "https://vanadarshini-images.s3.ap-south-1.amazonaws.com/mamandur-img/Mamandur-Forest-4.jpg",
    
    "https://vanadarshini-images.s3.ap-south-1.amazonaws.com/mamandur-img/1.jpg",
    "https://vanadarshini-images.s3.ap-south-1.amazonaws.com/mamandur-img/2.jpg",
   


    ]);
  
    return (
      <div>
        <div className="container">
          <div className="row">
            <div className="col-sm-12" id="Logo">
              <div className="row">
                <div className="slider_content_back">
                  <Carousel showThumbs={false} width="100%" autoPlay interval={3000} infiniteLoop>
                    {imageUrls.map((url, idx) => (
                      <div key={idx}>
                        <img
                          src={url}
                          alt={`Image ${idx + 1}`}
                          className="img-responsive img-rounded"
                          style={{ maxHeight: "400px", width: "100%", objectFit: "cover" }}
                        />
                      </div>
                    ))}
                  </Carousel>
                </div>
              </div>
            </div>
          </div>
          <div className="clearfix"></div>
          <br />
        </div>
      </div>
    );
  };
  
  export default MamandurImages;